"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require("babel-runtime/core-js/object/assign");

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MaterialShapesController = function () {
  function MaterialShapesController(ProductsDataProvider, ProductPartsDataProvider, $stateParams) {
    "ngInject";

    (0, _classCallCheck3.default)(this, MaterialShapesController);
    this.ProductsDataProvider = ProductsDataProvider;
    this.ProductPartsDataProvider = ProductPartsDataProvider;

    var product = ProductsDataProvider.products.findOne({ slug: $stateParams.product }),
        materials = product.materials,
        material = materials.find(function (material) {
      return material.slug == $stateParams.material;
    }),
        productShapes = material.spec.shapes,
        allShapes = ProductPartsDataProvider.shapes.find({}).map(function (shape) {
      return (0, _assign2.default)({}, shape);
    });

    allShapes.forEach(function (shape) {
      shape.assigned = productShapes.some(function (productShape) {
        return shape.id == productShape.id;
      });
    });

    this.shapes = allShapes;
    this.product = product;
    this.material = material;
    this.filterState = "assigned";
  }

  (0, _createClass3.default)(MaterialShapesController, [{
    key: "filter",
    value: function filter(shapes) {
      switch (this.filterState) {
        case 'assigned':
          return shapes.filter(function (shape) {
            return shape.assigned == true;
          });
        case 'unassigned':
          return shapes.filter(function (shape) {
            return shape.assigned != true;
          });
        case 'all':
          return shapes;
        default:
          throw new Error("unsupported filter type for shapes");
      }
    }
  }, {
    key: "setFilterState",
    value: function setFilterState(value, $event) {
      if ($event) {
        $event.preventDefault();
      }
      this.filterState = value;
    }
  }, {
    key: "changeShapeAssigment",
    value: function changeShapeAssigment(shape, $event) {
      $event.preventDefault();
      shape.__loading = true;
      var actionName = '';
      if (shape.assigned) {
        actionName = 'deleteProductMaterialShape';
      } else {
        actionName = 'addProductMaterialShape';
      }
      this.ProductsDataProvider[actionName](this.product.id, this.material.id, shape.id).then(function (responseShape) {
        delete shape.__loading;
        shape.assigned = !shape.assigned;
      });
    }
  }, {
    key: "updateName",
    value: function updateName(shape, $event) {
      $event.preventDefault();
      shape.__loading = true;
      this.ProductsDataProvider['updateName'](shape, 1).then(function (responseShape) {
        delete shape.__loading;
      });
    }
  }]);
  return MaterialShapesController;
}();

// WEBPACK FOOTER //


exports.default = MaterialShapesController;


/** WEBPACK FOOTER **
 ** ./client/app/modules/products/components/material-shape-spec/controller.js
 **/